var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-select"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('select',{domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}},[(_vm.placeholder)?_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._l((_vm.mappedOptions),function(ref){
var key = ref.key;
var label = ref.label;
var value = ref.value;
return _c('option',{key:key,domProps:{"value":value}},[_vm._v("\n            "+_vm._s(label)+"\n        ")])}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }